import React, { Component } from 'react';
import { AbstractIcon } from './AbstractIcon';
import { AbstractIconDefaultProps, AbstractIconPropTypes } from './utils';

export class CaretDownIcon extends Component {
    static defaultProps = AbstractIconDefaultProps;
    static propTypes = AbstractIconPropTypes;

    render() {
        const props = this.props;

        return (
            <AbstractIcon viewBox="0 0 10 6" {...props}>
                <path d="M0 0.5L5 5.5L10 0.5H0Z" fill="currentColor" />
            </AbstractIcon>
        );
    }
}
